import {
  ListItem, ListItemAvatar, ListItemText, Skeleton,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  listItemProfile: {
    display: 'inline-flex',
    paddingBottom: 0,
    paddingTop: 0,
    width: 'auto',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const ProfileSkeleton = () => {
  const { classes } = useStyles();

  return (
    <ListItem
      className={classes.listItemProfile}
      button
      disableGutters
    >
      <ListItemAvatar>
        <Skeleton
          variant="circular"
          height={33}
          width={33}
        />
      </ListItemAvatar>

      <ListItemText
        disableTypography
        primary={(
          <Skeleton width={200} />
        )}
      />
    </ListItem>
  );
};
